export default "__VITE_ASSET__7f7a89ab__"